import { assert } from '@ember/debug';

import FlashMessages from 'ember-cli-flash/services/flash-messages';

export default class extends FlashMessages {
  /**
   * Triggers a toast info
   *
   * @public
   * @method toastInfo
   *
   * @param  {String} message Message to display
   * @returns void
   */
  toastInfo(message) {
    assert('A flashMessage must have a message', message);

    return this.add({
      componentKind: 'toast',
      componentName: 'toast',
      type: 'info',
      priority: 101,
      message,
    }).getFlashObject();
  }

  toastError(message) {
    assert('A flashMessage must have a message', message);

    return this.add({
      componentKind: 'toast',
      componentName: 'toast',
      type: 'error',
      priority: 300,
      message,
    }).getFlashObject();
  }
}
